/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListMarketingMessagesRequest} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'
import {ListMarketingMessagesResponse} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'


export const listMarketingMessages = (request: ListMarketingMessagesRequest, options?: CashRequestOptions) => post<ListMarketingMessagesRequest, ListMarketingMessagesResponse>("/2.0/cash/list-marketing-messages", request, {...options, rejectOnError: true })